<template>
  <div class="justify-content-center mt-4 mb-2">
    <h5 class="text-center">GCash Payment Instructions</h5>
    <div class="px-5">
      <div class="row justify-content-center mb-2">
        Step 1: Open the GCash app and tap "Send Money" to send to 0917 157 6763.
        Or scan the QR code below.
      </div>
      <div class="row justify-content-center mb-3">
        <img src="resources/images/gcash/gcashQR.png" width="240" alt="GCash Step 3" />
      </div>
      <div class="row justify-content-center mb-2">
        Step 2: Enter the following details and tap "Next".
      </div>
      <div class="row justify-content-center mb-2">
        <ul>
          <li>Send to: Charisse Mae P.</li>
          <li>Amount: P{{ gcashPrice }}</li>
          <li>Message: {{ $store.state.user.email }}</li>
        </ul>
      </div>
      <div class="row justify-content-center mb-3">
        Step 3: Confirm the transaction and press the button below to notify us. All done!
      </div>
      <div class="row justify-content-center mb-3">
        <a-button
          type="primary"
          :style="{ backgroundColor: '#19D797', borderColor: '#19D797', color: 'white' }"
          :loading="gcashInProcess"
          :disabled="gcashSubmitted"
          @click="reportGcashPayment"
        >
          <strong>I completed the GCash payment</strong>
        </a-button>
      </div>
      <div class="row justify-content-center mb-2">
        We will provision your access shortly. You will be notified via email. Please note that it may take up to 24 hours. Please contact us via email
        or through our Facebook page, if you have any questions.
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import "./style.module.scss";
</style>

<script>
import * as firebase from '@/services/firebase/'
// import _ from 'lodash'

export default {
  props: ['gcashPrice'],
  components: {
  },
  data() {
    return {
      pricingIcon: 'fe fe-inbox font-size-40 mb-3 d-block',
      btnCardLoading: false,
      btnGcashLoading: false,
      gcashInProcess: false,
      gcashSubmitted: false,
    }
  },
  methods: {
    cap(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    checkout() {
      this.btnCardLoading = true
      this.$emit('checkout', this.tier, this.term, this.currency)
      console.log('Checkout initiates: ' + this.tier + this.term + this.currency)
    },
    openGcash() {
      // this.btnGcashLoading = true
      this.$emit('openGcash', this.tier, this.term, this.currency)
      console.log('GCash initiated: ' + this.tier + this.term + this.currency)
    },
    async reportGcashPayment() {
      const gcashPayment = {
        uid: this.$store.state.user.id,
        email: this.$store.state.user.email,
        paymentDate: Math.floor(new Date().getTime() / 1000),
        paymentType: 'GCash',
      }

      this.gcashInProcess = true
      console.log('Adding GCash payment to user')
      await firebase.firebaseFirestore
        .collection('users')
        .doc(this.$store.state.user.id)
        .update({
          latestGcashPayment: Math.floor(new Date().getTime() / 1000),
        })
        .then(() => {
          console.log('GCash payment saved to user')
        })
        .catch(err => console.log(err))
      console.log('Logging GCash payment event')
      await firebase.firebaseFirestore
        .collection('gcash_events')
        .doc()
        .set(gcashPayment)
        .then(() => {
          console.log('GCash payment event logged')
          this.gcashInProcess = false
          this.gcashSubmitted = true
        })
        .catch(err => console.log(err))
    },
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
  },
}
</script>
